/* assets/revendeurs-map.js
   Initialise la carte des revendeurs. Appelé une seule fois par section,
   quand la section entre dans le viewport. */
(function () {
  'use strict';

  // Tuiles CARTO Positron : fond sobre et clair, cohérent avec la DA.
  // Ce sont des tuiles OpenStreetMap restylées — attribution obligatoire.
  // Depuis sept. 2026 CARTO exige une clé (gratuite, 5 M requêtes/mois),
  // sinon les tuiles arrivent avec le filigrane « API KEY REQUIRED ».
  // Clé demandée le 2026-09-02 pour la-pelucherie.com, forcément publique
  // ici (appel côté client), copie dans sops (lp / CARTO_BASEMAPS_KEY).
  var CARTO_KEY = 'cb1_2tlu_1_1b6074817317d834f8c606d7';
  // CARTO dessine les noms dans les tuiles, en anglais pour les pays, régions et
  // arrondissements (« Island of France », « 15th Arrondissement ») : intraduisible.
  // Fond sans aucun nom, et noms superposés seulement à partir du zoom où ils
  // redeviennent locaux (rues, communes) — vérifié tuile par tuile sur Paris.
  var TILES_FOND = 'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png?key=' + CARTO_KEY;
  var TILES_NOMS = 'https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png?key=' + CARTO_KEY;
  var ZOOM_NOMS = 13;
  var ATTRIB = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

  // Point de départ avant le premier cadrage (France métropolitaine).
  var VUE_INITIALE = { center: [46.6, 2.4], zoom: 5 };

  function pinIcon() {
    return L.divIcon({
      className: '',
      iconSize: [28, 36],
      iconAnchor: [14, 36],
      tooltipAnchor: [0, -30],
      html:
        '<svg class="revendeurs-map__pin" viewBox="0 0 28 36" aria-hidden="true">' +
        '<path fill="currentColor" d="M14 0C6.8 0 1 5.8 1 13c0 9.4 11.6 22 12.1 22.5a1.2 1.2 0 0 0 1.8 0C15.4 35 27 22.4 27 13 27 5.8 21.2 0 14 0z"/>' +
        '<circle cx="14" cy="13" r="5" fill="#fff"/></svg>'
    });
  }

  // Adresse mise en avant (showroom, Bon Marché…) : même goutte que les
  // autres, plus grande, avec le lapin de la marque dans la tête. Une goutte
  // pointe l'adresse ; un médaillon rond flottant ne se lisait pas comme un
  // lieu. Le SVG du lapin vient du gabarit <template data-revendeurs-lapin>.
  function lapinIcon(root) {
    var tpl = root.querySelector('[data-revendeurs-lapin]');
    var svg = tpl ? tpl.innerHTML : '';
    return L.divIcon({
      className: '',
      iconSize: [40, 52],
      iconAnchor: [20, 52],
      tooltipAnchor: [0, -46],
      html:
        '<div class="revendeurs-map__pin-phare">' +
        '<svg class="revendeurs-map__pin-phare-goutte" viewBox="0 0 28 36" aria-hidden="true">' +
        '<path fill="currentColor" d="M14 0C6.8 0 1 5.8 1 13c0 9.4 11.6 22 12.1 22.5a1.2 1.2 0 0 0 1.8 0C15.4 35 27 22.4 27 13 27 5.8 21.2 0 14 0z"/>' +
        '<circle cx="14" cy="13" r="9.5" fill="#fff"/></svg>' +
        svg +
        '</div>'
    });
  }

  // En dessous de ce zoom (France entière, monde), les adresses phares
  // comptent dans les clusters comme les autres : deux lapins posés sur un
  // rond « 14 » ne se comprenaient pas. À partir du zoom « Paris », elles
  // sortent du cluster et restent visibles en goutte lapin.
  var ZOOM_PHARES = 11;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Textes traduits, fournis par la page (fichiers de langue du thème).
  var I18N = { website: 'Voir le site', byAppointment: 'Sur rendez-vous', unavailable: '', zoomIn: 'Zoom avant', zoomOut: 'Zoom arrière' };

  // Seuls http et https deviennent des liens : un `javascript:` saisi dans la
  // fiche ne doit jamais atterrir dans un href.
  function lienSur(url) {
    return typeof url === 'string' && /^https?:\/\//i.test(url.trim());
  }

  // Message de repli, posé une seule fois dans la zone de carte. La liste sous
  // la carte reste complète : le visiteur n'est jamais laissé devant du vide.
  function avertir(root) {
    if (!I18N.unavailable || root.querySelector('.revendeurs-map__notice')) return;
    var stage = root.querySelector('.revendeurs-map__stage') || root;
    var p = document.createElement('p');
    p.className = 'revendeurs-map__notice';
    p.setAttribute('role', 'status');
    p.textContent = I18N.unavailable;
    stage.appendChild(p);
  }

  function detailHtml(r) {
    var out = '<span class="revendeurs-map__tip-name">' + escapeHtml(r.nom) + '</span>';
    if (r.rdv) out += '<span class="revendeurs-map__tip-line">' + escapeHtml(I18N.byAppointment) + '</span>';
    var ligneVille = [r.cp, r.ville].filter(Boolean).join(' ');
    if (r.adresse) out += '<span class="revendeurs-map__tip-line">' + escapeHtml(r.adresse) + '</span>';
    if (ligneVille) out += '<span class="revendeurs-map__tip-line">' + escapeHtml(ligneVille) + '</span>';
    if (r.pays && r.pays !== 'France') out += '<span class="revendeurs-map__tip-line">' + escapeHtml(r.pays) + '</span>';
    if (r.tel) {
      out += '<span class="revendeurs-map__tip-line"><a href="tel:' +
        escapeHtml(r.tel.replace(/[^\d+]/g, '')) + '">' + escapeHtml(r.tel) + '</a></span>';
    }
    if (lienSur(r.site)) {
      out += '<span class="revendeurs-map__tip-line"><a href="' + escapeHtml(r.site.trim()) +
        '" target="_blank" rel="noopener">' + escapeHtml(I18N.website) + '</a></span>';
    }
    return out;
  }

  function initMap(root) {
    var dataEl = root.querySelector('[data-revendeurs-data]');
    var canvas = root.querySelector('[data-revendeurs-canvas]');
    if (!dataEl || !canvas) return;

    var revendeurs;
    try {
      revendeurs = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; // Donnée illisible : on laisse la liste en dessous faire le travail.
    }
    if (!revendeurs.length) return;

    var tactile = window.matchMedia('(hover: none)').matches;

    var map = L.map(canvas, {
      center: VUE_INITIALE.center,
      zoom: VUE_INITIALE.zoom,
      zoomControl: false, // recréé plus bas avec des infobulles traduites
      scrollWheelZoom: false // Ne pas voler le scroll de la page.
    });
    map.on('click', function () { map.scrollWheelZoom.enable(); });
    map.on('mouseout', function () { map.scrollWheelZoom.disable(); });

    L.control.zoom({ zoomInTitle: I18N.zoomIn, zoomOutTitle: I18N.zoomOut }).addTo(map);

    var tuilesPerdues = 0;
    function tuilePerdue() { if (++tuilesPerdues === 4) avertir(root); }
    L.tileLayer(TILES_FOND, { attribution: ATTRIB, maxZoom: 19 })
      .on('tileerror', tuilePerdue)
      .addTo(map);
    // Les noms passent au-dessus du fond mais sous les marqueurs, et ne captent
    // aucun clic. minZoom : en dessous, aucune tuile de noms n'est chargée.
    var paneNoms = map.createPane('revendeurs-noms');
    paneNoms.style.zIndex = 250;
    paneNoms.style.pointerEvents = 'none';
    L.tileLayer(TILES_NOMS, { pane: 'revendeurs-noms', minZoom: ZOOM_NOMS, maxZoom: 19 })
      .on('tileerror', tuilePerdue)
      .addTo(map);

    var cluster = L.markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 45,
      iconCreateFunction: function (c) {
        return L.divIcon({
          className: '',
          iconSize: [36, 36],
          html: '<div class="revendeurs-map__cluster">' + c.getChildCount() + '</div>'
        });
      }
    });

    var parZone = { tous: [] };
    revendeurs.forEach(function (r) {
      // number_decimal peut être sérialisé en chaîne par Liquid : on force le type.
      var lat = Number(r.lat), lng = Number(r.lng);
      if (!isFinite(lat) || !isFinite(lng)) return;

      var marker = L.marker([lat, lng], {
        icon: r.phare ? lapinIcon(root) : pinIcon(),
        alt: r.nom,
        keyboard: true,
        title: r.nom,
        // Une adresse phare passe au-dessus des gouttes et des clusters voisins.
        zIndexOffset: r.phare ? 1000 : 0,
        phare: !!r.phare
      });
      var html = detailHtml(r);

      if (tactile) {
        // Au doigt, le survol n'existe pas : la fiche s'ouvre au tap dans une
        // bulle Leaflet. autoPan décale la carte si la bulle sort du cadre.
        marker.bindPopup(html, {
          className: 'revendeurs-map__pop',
          closeButton: true,
          autoPan: true,
          autoPanPadding: [24, 24],
          minWidth: 150,
          maxWidth: 230
        });
      } else {
        marker.bindTooltip(html, {
          direction: 'top',
          className: 'revendeurs-map__tip',
          opacity: 1
        });
        // Le clavier doit ouvrir le même détail que la souris.
        marker.on('focus', function () { marker.openTooltip(); });
        marker.on('blur', function () { marker.closeTooltip(); });
      }

      parZone.tous.push(marker);
      (parZone[r.zone] = parZone[r.zone] || []).push(marker);
      // Paris est en France : le filtre France doit inclure les boutiques
      // parisiennes, sans quoi un visiteur français en perd seize.
      if (r.zone === 'paris') {
        (parZone.france = parZone.france || []).push(marker);
      }
    });

    // Les adresses phares changent de couche selon le zoom : dans le cluster
    // en vue large, hors cluster (toujours visibles) dès la vue « Paris ».
    var phares = L.layerGroup();
    var zoneCourante = 'tous';

    function afficher() {
      var sorties = map.getZoom() >= ZOOM_PHARES;
      cluster.clearLayers();
      phares.clearLayers();
      var enCluster = [];
      (parZone[zoneCourante] || []).forEach(function (m) {
        if (m.options.phare && sorties) phares.addLayer(m); else enCluster.push(m);
      });
      cluster.addLayers(enCluster);
    }

    afficher();
    map.addLayer(cluster);
    map.addLayer(phares);
    map.on('zoomend', afficher);
    canvas.classList.add('is-ready');

    // Cadrer sur les marqueurs réellement affichés, plutôt que sur des vues
    // codées en dur : la carte reste juste quel que soit le filtre, et un
    // recadrage rattrape toujours un zoom laissé par un clic sur un cluster.
    function cadrer(zone) {
      var markers = parZone[zone] || [];
      if (!markers.length) return;
      map.fitBounds(L.featureGroup(markers).getBounds(), {
        padding: [40, 40],
        maxZoom: 14 // Un revendeur isolé ne doit pas coller la carte au trottoir.
      });
    }

    cadrer('tous');

    Array.prototype.forEach.call(root.querySelectorAll('[data-revendeurs-filter]'), function (btn) {
      btn.addEventListener('click', function () {
        var zone = btn.getAttribute('data-revendeurs-filter');
        Array.prototype.forEach.call(root.querySelectorAll('[data-revendeurs-filter]'), function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        zoneCourante = zone;
        afficher();
        map.closePopup();
        cadrer(zone); // le zoomend qui suit replace les lapins selon le zoom
      });
    });
  }

  function loadAsset(tag, attrs) {
    return new Promise(function (resolve, reject) {
      var el = document.createElement(tag);
      Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
      el.onload = resolve;
      el.onerror = reject;
      document.head.appendChild(el);
    });
  }

  // Rien n'est téléchargé tant que la carte n'approche pas du viewport.
  function lazyInit(root) {
    var started = false;
    function boot() {
      if (started) return;
      started = true;
      try {
        var t = JSON.parse(root.getAttribute('data-revendeurs-i18n') || '{}');
        for (var k in t) if (t[k]) I18N[k] = t[k];
      } catch (e) { /* on garde les libellés par défaut */ }
      var urls = JSON.parse(root.getAttribute('data-revendeurs-assets'));
      Promise.all([
        loadAsset('link', { rel: 'stylesheet', href: urls.leafletCss }),
        loadAsset('link', { rel: 'stylesheet', href: urls.clusterCss })
      ])
        .then(function () { return loadAsset('script', { src: urls.leafletJs }); })
        .then(function () { return loadAsset('script', { src: urls.clusterJs }); })
        .then(function () { initMap(root); })
        .catch(function () { avertir(root); });
    }

    if (!('IntersectionObserver' in window)) return boot();
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { io.disconnect(); boot(); return; }
      }
    }, { rootMargin: '300px' });
    io.observe(root);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-revendeurs-map]'), lazyInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
